import React from 'react';
import {
    CardElement,
    injectStripe,
    CardNumberElement,
    CardExpiryElement,
} from 'react-stripe-elements';
import { createAccount } from '../../../firebase/api/stripe';
import { getAuthUser, setAuthUser } from '../../../static/localStorage';

class StripeForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleSubmit = async event => {
        const { stripe, toggle } = this.props;
        event.preventDefault();
        const { token, error } = await stripe.createToken({ currency: 'usd' });
        createAccount(token).then(result => {
            const account_id = result.data;
            const authUser = getAuthUser();
            authUser.stripeAccount = account_id;
            setAuthUser(authUser);
        });
        toggle();
    };

    handleBlur = () => {};
    handleChange = change => {};
    handleFocus = () => {};
    handleReady = () => {};

    render() {
        return (
            <form
                className="stripe-card d-flex justify-content-center stripe-form mt-4"
                onSubmit={this.handleSubmit}
            >
                <CardNumberElement className="stripe-card-number" />
                <CardExpiryElement className="stripe-card-expiry" />
                <div className="stripe-btn mt-4">
                    <button className="btn btn-dark primary">Add</button>
                </div>
            </form>
        );
    }
}

export default injectStripe(StripeForm);
